<template>
  <div>
    <v-form @submit.prevent="submit" ref="form">
      <v-file-input
        show-size
        v-model="file"
        label="펌웨어"
        :disabled="edit"
        accept="application/octet-stream"
      ></v-file-input>
      <v-select
        outlined
        label="대상 유형(deviceType)"
        :items="items.deviceType"
        v-model="form.deviceType"
      ></v-select>
      <v-select
        outlined
        label="대상 모델(modelNo)"
        :items="items.modelNo"
        v-model="form.modelNo"
      ></v-select>
      <v-text-field
        outlined
        label="버전"
        v-model="form.version"
      ></v-text-field>
      <v-select
        outlined
        label="데이터 분할"
        :items="items.div"
        v-model="form.div"
      ></v-select>
      <v-textarea
        outlined
        label="설명"
        v-model="form.description"
      ></v-textarea>

      <v-btn type="submit" color="primary" :loading="loading">{{ submitText }}</v-btn>
    </v-form>
  </div>
</template>

<script>
import { getFirmware, addFirmware, editFirmware } from '@/api'

export default {
  props: {
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      id: null,
      loading: false,
      form: {
        deviceType: 8,
        modelNo: 'LDT-300BS',
        version: null,
        div: 4096,
        description: null
      },
      file: null,
      items: {
        div: [4096],
        modelNo: ['LDT-300BS', 'LDT-300BS-FORK', 'LDT-100BS'],
        deviceType: [8, 11, 12]
      }
    }
  },
  computed: {
    submitText () {
      return this.edit ? '수정' : '등록'
    }
  },
  async beforeRouteEnter (to, from, next) {
    const id = to.params.id

    if (!id) return next()

    try {
      const firmware = await getFirmware(id)

      const {
        deviceType,
        modelNo,
        version,
        div,
        description,
        originalname,
        size
      } = firmware

      next(vm => {
        if (firmware) {
          vm.id = firmware.id
          Object.assign(vm.form, {
            deviceType,
            modelNo,
            version,
            div,
            description
          })
          vm.file = {
            name: originalname,
            size
          }
        }
      })
    } catch (err) {
      console.error(err.message)
      next()
    }
  },
  methods: {
    async submit () {
      if (this.loading) return
      if (!this.$refs.form.validate()) return
      if (!confirm('이대로 적용 하시겠습니까?')) return
      this.loading = true
      try {
        if (this.edit) {
          await this.putFirmware()
        } else {
          await this.postFirmware()
        }
        this.$router.go(-1)
      } catch (err) {
        alert(err.message)
      }
      this.loading = false
    },
    postFirmware () {
      const formdata = new FormData()
      formdata.append('file', this.file)
      Object.entries(this.form).forEach(([key, value]) => {
        formdata.append(key, value)
      })

      return addFirmware(formdata)
    },
    putFirmware () {
      return editFirmware(this.id, this.form)
    }
  }
}
</script>
